import React from 'react';
import ViewFiltersDesktop from '../../application/timetable/filter/ViewFiltersDesktop';

const LineupActions = ({ days, selected, switchDay, toEditMode, toggleListView, isListView }) => (
    <React.Fragment>
        <div className="ckp-admin-lineup-actions">
            <a onClick={toEditMode} className="ckp-admin-lineup-days-edit ckp-ts-h4">
                <i className="fa fa-edit" />
                Edit Days
            </a>
            <div className="ckp-admin-lineup-actions-bar">
                <div className="ckp-admin-lineup-days-options">
                    <ul className="ckp-timetable-actions-group is-not-responsive">
                        {days.map(d => (
                            <li
                                value={d.fullDate}
                                onClick={() => switchDay(d.fullDate)}
                                className={`ckp-timetable-actions-option ${
                                    selected === d.fullDate ? 'is-selected' : ''
                                }`}
                                key={d.fullDate}
                            >
                                <span className="ckp-timetable-actions-label">{d.weekDay}</span>
                                <span className="ckp-timetable-actions-label is-small">{d.dayAndMonth}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <ViewFiltersDesktop isAdmin isListView={isListView} toggleListView={toggleListView} />
            </div>
        </div>
    </React.Fragment>
);

export default LineupActions;
